import {useMutation, useQueryClient} from 'react-query';

import useAlerts from '@/hooks/useAlerts';
import {CACHE_KEY_CNAE_NOMENCLATOR} from '@/modules/configuration/contants/CNAENomenclator';
import {fields} from '@/modules/configuration/contants/CNAENomenclator.form';
import CNAENomenclatorApiService from '@/modules/configuration/services/CNAENomenclatorApiService';
import {createFieldsHook} from '@/utils/createFieldsHook';
import {createGetOneHook} from '@/utils/createGetOneHook';

export const useGetOneCNAENomenclator = createGetOneHook(CNAENomenclatorApiService, 'id', CACHE_KEY_CNAE_NOMENCLATOR);
export const useFields = createFieldsHook('configuration', fields);

export const useActive = () => {
  const queryClient = useQueryClient();

  const { putErrorCode } = useAlerts();

  const { mutateAsync: activate, isLoading: isActivating } = useMutation(CNAENomenclatorApiService.activateMany, {
    onSuccess: ({data}) => {
      queryClient.resetQueries(data?._id);
    },
    onError: (e) => {
      putErrorCode(e);
    }
  });
  return {
    activate,
    isActivating
  };
};

export const useDeactivate = () => {
  const queryClient = useQueryClient();

  const { putErrorCode } = useAlerts();

  const { mutateAsync: deactivate, isLoading: isDeactivating } = useMutation(CNAENomenclatorApiService.deactivateMany, {
    onSuccess: ({data}) => {
      queryClient.resetQueries(data?._id);
    },
    onError: (e) => {
      putErrorCode(e);
    }
  });
  return {
    deactivate,
    isDeactivating
  };
};

export const useAllow = () => {
  const queryClient = useQueryClient();

  const { putErrorCode } = useAlerts();

  const { mutateAsync: allow, isLoading: isAllowing } = useMutation(CNAENomenclatorApiService.allowMany, {
    onSuccess: ({data}) => {
      queryClient.resetQueries(data?._id);
    },
    onError: (e) => {
      putErrorCode(e);
    }
  });
  return {
    allow,
    isAllowing
  };
};

export const useProhibit = () => {
  const queryClient = useQueryClient();

  const { putErrorCode } = useAlerts();

  const { mutateAsync: prohibit, isLoading: isProhibiting } = useMutation(CNAENomenclatorApiService.prohibitMany, {
    onSuccess: ({data}) => {
      queryClient.resetQueries(data?._id);
    },
    onError: (e) => {
      putErrorCode(e);
    }
  });
  return {
    prohibit,
    isProhibiting
  };
};
